import { VEHICLES } from './constants';
import getLeaseBaseFeeFromWeight from './getLeaseBaseFeeFromWeight';
import getBusBaseFeeFromWeight from './getBusesBaseFeeFromWeight';

const getBaseFeeFromWeight = (options) => {
  if (options.selectedVehicleType === VEHICLES.BUSES_TRAILER) {
    return getBusBaseFeeFromWeight(options);
  }
  return getLeaseBaseFeeFromWeight(options);
};

export default getBaseFeeFromWeight;



// WEBPACK FOOTER //
// ./src/modules/getBaseFeeFromWeight.js